import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin, FiFacebook, FiInstagram, FiLinkedin } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info - Using the new logo */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-3">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753400749025-Screenshot_20250529_131941_Chrome.jpg"
                alt="LEWIS PROPERTY REMODELING"
                className="h-12 w-auto object-contain rounded-md"
              />
              <div className="flex flex-col">
                <span className="font-bold text-base md:text-lg">LEWIS PROPERTY</span>
                <span className="font-bold text-sm md:text-base -mt-1">REMODELING L.L.C.</span>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-4">General Contractor #PA141245</p>
            <p className="text-gray-300 mb-6 max-w-md">
              Transforming homes with expert craftsmanship and exceptional service. Your trusted partner for all remodeling needs with over 15 years of experience.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors"
              >
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors"
              >
                <SafeIcon icon={FiInstagram} className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors"
              >
                <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-blue-400" />
                <a
                  href="tel:+16078884189"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  (607) 888-4189
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-blue-400" />
                <a
                  href="mailto:lewispropertyremodeling@gmail.com"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  lewispropertyremodeling@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-blue-400 mt-0.5" />
                <span className="text-gray-300">
                  New York, New Jersey, and Pennsylvania
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} LEWIS PROPERTY REMODELING L.L.C. All rights reserved. PA License #PA141245
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
              Licensing
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;